module.exports = __webpack_public_path__ + "img/yellow-icon(1).ff575c89.png";